/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalCommonSharingVisibilityFromJSON, InternalCommonSharingVisibilityToJSON, } from './InternalCommonSharingVisibility';
/**
 * Check if a given object implements the InternalCommonUserConfig interface.
 */
export function instanceOfInternalCommonUserConfig(value) {
    if (!('privateProfile' in value) || value['privateProfile'] === undefined)
        return false;
    if (!('optOutOfDirectory' in value) || value['optOutOfDirectory'] === undefined)
        return false;
    if (!('optOutOfGroupDirectories' in value) || value['optOutOfGroupDirectories'] === undefined)
        return false;
    if (!('optOutOfMessaging' in value) || value['optOutOfMessaging'] === undefined)
        return false;
    if (!('shareGender' in value) || value['shareGender'] === undefined)
        return false;
    if (!('sharePrefixFirstname' in value) || value['sharePrefixFirstname'] === undefined)
        return false;
    if (!('shareHonoraryTitle' in value) || value['shareHonoraryTitle'] === undefined)
        return false;
    if (!('sharePrefixName' in value) || value['sharePrefixName'] === undefined)
        return false;
    if (!('shareSuffixName' in value) || value['shareSuffixName'] === undefined)
        return false;
    if (!('shareMaidenname' in value) || value['shareMaidenname'] === undefined)
        return false;
    if (!('shareBirthday' in value) || value['shareBirthday'] === undefined)
        return false;
    if (!('shareBirthplace' in value) || value['shareBirthplace'] === undefined)
        return false;
    if (!('shareHeadline' in value) || value['shareHeadline'] === undefined)
        return false;
    if (!('shareLiveLocation' in value) || value['shareLiveLocation'] === undefined)
        return false;
    if (!('shareSubNetworks' in value) || value['shareSubNetworks'] === undefined)
        return false;
    if (!('shareNationalities' in value) || value['shareNationalities'] === undefined)
        return false;
    if (!('shareResume' in value) || value['shareResume'] === undefined)
        return false;
    if (!('shareSummary' in value) || value['shareSummary'] === undefined)
        return false;
    if (!('shareIndustries' in value) || value['shareIndustries'] === undefined)
        return false;
    if (!('shareSkills' in value) || value['shareSkills'] === undefined)
        return false;
    if (!('shareFacebookProfileUrl' in value) || value['shareFacebookProfileUrl'] === undefined)
        return false;
    if (!('shareInstagramProfileUrl' in value) || value['shareInstagramProfileUrl'] === undefined)
        return false;
    if (!('shareTwitter' in value) || value['shareTwitter'] === undefined)
        return false;
    if (!('shareSkype' in value) || value['shareSkype'] === undefined)
        return false;
    if (!('shareLinkedinProfileUrl' in value) || value['shareLinkedinProfileUrl'] === undefined)
        return false;
    if (!('shareWebsite' in value) || value['shareWebsite'] === undefined)
        return false;
    if (!('shareBbm' in value) || value['shareBbm'] === undefined)
        return false;
    if (!('shareEmail' in value) || value['shareEmail'] === undefined)
        return false;
    if (!('shareEmail2' in value) || value['shareEmail2'] === undefined)
        return false;
    if (!('shareEmail3' in value) || value['shareEmail3'] === undefined)
        return false;
    if (!('shareMobilePerso' in value) || value['shareMobilePerso'] === undefined)
        return false;
    if (!('shareLandlinePerso' in value) || value['shareLandlinePerso'] === undefined)
        return false;
    if (!('shareMobilePro' in value) || value['shareMobilePro'] === undefined)
        return false;
    if (!('shareLandlinePro' in value) || value['shareLandlinePro'] === undefined)
        return false;
    if (!('sharePostalPersonal' in value) || value['sharePostalPersonal'] === undefined)
        return false;
    if (!('sharePostalWork' in value) || value['sharePostalWork'] === undefined)
        return false;
    if (!('shareMemberships' in value) || value['shareMemberships'] === undefined)
        return false;
    if (!('shareEducations' in value) || value['shareEducations'] === undefined)
        return false;
    if (!('shareExperiences' in value) || value['shareExperiences'] === undefined)
        return false;
    return true;
}
export function InternalCommonUserConfigFromJSON(json) {
    return InternalCommonUserConfigFromJSONTyped(json, false);
}
export function InternalCommonUserConfigFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'privateProfile': json['private_profile'],
        'optOutOfDirectory': json['opt_out_of_directory'],
        'optOutOfGroupDirectories': json['opt_out_of_group_directories'],
        'optOutOfMessaging': json['opt_out_of_messaging'],
        'shareGender': InternalCommonSharingVisibilityFromJSON(json['share_gender']),
        'sharePrefixFirstname': InternalCommonSharingVisibilityFromJSON(json['share_prefix_firstname']),
        'shareHonoraryTitle': InternalCommonSharingVisibilityFromJSON(json['share_honorary_title']),
        'sharePrefixName': InternalCommonSharingVisibilityFromJSON(json['share_prefix_name']),
        'shareSuffixName': InternalCommonSharingVisibilityFromJSON(json['share_suffix_name']),
        'shareMaidenname': InternalCommonSharingVisibilityFromJSON(json['share_maidenname']),
        'shareBirthday': InternalCommonSharingVisibilityFromJSON(json['share_birthday']),
        'shareBirthplace': InternalCommonSharingVisibilityFromJSON(json['share_birthplace']),
        'shareHeadline': InternalCommonSharingVisibilityFromJSON(json['share_headline']),
        'shareLiveLocation': InternalCommonSharingVisibilityFromJSON(json['share_live_location']),
        'shareSubNetworks': InternalCommonSharingVisibilityFromJSON(json['share_sub_networks']),
        'shareNationalities': InternalCommonSharingVisibilityFromJSON(json['share_nationalities']),
        'shareResume': InternalCommonSharingVisibilityFromJSON(json['share_resume']),
        'shareSummary': InternalCommonSharingVisibilityFromJSON(json['share_summary']),
        'shareIndustries': InternalCommonSharingVisibilityFromJSON(json['share_industries']),
        'shareSkills': InternalCommonSharingVisibilityFromJSON(json['share_skills']),
        'shareFacebookProfileUrl': InternalCommonSharingVisibilityFromJSON(json['share_facebook_profile_url']),
        'shareInstagramProfileUrl': InternalCommonSharingVisibilityFromJSON(json['share_instagram_profile_url']),
        'shareTwitter': InternalCommonSharingVisibilityFromJSON(json['share_twitter']),
        'shareSkype': InternalCommonSharingVisibilityFromJSON(json['share_skype']),
        'shareLinkedinProfileUrl': InternalCommonSharingVisibilityFromJSON(json['share_linkedin_profile_url']),
        'shareWebsite': InternalCommonSharingVisibilityFromJSON(json['share_website']),
        'shareBbm': InternalCommonSharingVisibilityFromJSON(json['share_bbm']),
        'shareEmail': InternalCommonSharingVisibilityFromJSON(json['share_email']),
        'shareEmail2': InternalCommonSharingVisibilityFromJSON(json['share_email2']),
        'shareEmail3': InternalCommonSharingVisibilityFromJSON(json['share_email3']),
        'shareMobilePerso': InternalCommonSharingVisibilityFromJSON(json['share_mobile_perso']),
        'shareLandlinePerso': InternalCommonSharingVisibilityFromJSON(json['share_landline_perso']),
        'shareMobilePro': InternalCommonSharingVisibilityFromJSON(json['share_mobile_pro']),
        'shareLandlinePro': InternalCommonSharingVisibilityFromJSON(json['share_landline_pro']),
        'sharePostalPersonal': InternalCommonSharingVisibilityFromJSON(json['share_postal_personal']),
        'sharePostalWork': InternalCommonSharingVisibilityFromJSON(json['share_postal_work']),
        'shareMemberships': InternalCommonSharingVisibilityFromJSON(json['share_memberships']),
        'shareEducations': InternalCommonSharingVisibilityFromJSON(json['share_educations']),
        'shareExperiences': InternalCommonSharingVisibilityFromJSON(json['share_experiences']),
    };
}
export function InternalCommonUserConfigToJSON(json) {
    return InternalCommonUserConfigToJSONTyped(json, false);
}
export function InternalCommonUserConfigToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'private_profile': value['privateProfile'],
        'opt_out_of_directory': value['optOutOfDirectory'],
        'opt_out_of_group_directories': value['optOutOfGroupDirectories'],
        'opt_out_of_messaging': value['optOutOfMessaging'],
        'share_gender': InternalCommonSharingVisibilityToJSON(value['shareGender']),
        'share_prefix_firstname': InternalCommonSharingVisibilityToJSON(value['sharePrefixFirstname']),
        'share_honorary_title': InternalCommonSharingVisibilityToJSON(value['shareHonoraryTitle']),
        'share_prefix_name': InternalCommonSharingVisibilityToJSON(value['sharePrefixName']),
        'share_suffix_name': InternalCommonSharingVisibilityToJSON(value['shareSuffixName']),
        'share_maidenname': InternalCommonSharingVisibilityToJSON(value['shareMaidenname']),
        'share_birthday': InternalCommonSharingVisibilityToJSON(value['shareBirthday']),
        'share_birthplace': InternalCommonSharingVisibilityToJSON(value['shareBirthplace']),
        'share_headline': InternalCommonSharingVisibilityToJSON(value['shareHeadline']),
        'share_live_location': InternalCommonSharingVisibilityToJSON(value['shareLiveLocation']),
        'share_sub_networks': InternalCommonSharingVisibilityToJSON(value['shareSubNetworks']),
        'share_nationalities': InternalCommonSharingVisibilityToJSON(value['shareNationalities']),
        'share_resume': InternalCommonSharingVisibilityToJSON(value['shareResume']),
        'share_summary': InternalCommonSharingVisibilityToJSON(value['shareSummary']),
        'share_industries': InternalCommonSharingVisibilityToJSON(value['shareIndustries']),
        'share_skills': InternalCommonSharingVisibilityToJSON(value['shareSkills']),
        'share_facebook_profile_url': InternalCommonSharingVisibilityToJSON(value['shareFacebookProfileUrl']),
        'share_instagram_profile_url': InternalCommonSharingVisibilityToJSON(value['shareInstagramProfileUrl']),
        'share_twitter': InternalCommonSharingVisibilityToJSON(value['shareTwitter']),
        'share_skype': InternalCommonSharingVisibilityToJSON(value['shareSkype']),
        'share_linkedin_profile_url': InternalCommonSharingVisibilityToJSON(value['shareLinkedinProfileUrl']),
        'share_website': InternalCommonSharingVisibilityToJSON(value['shareWebsite']),
        'share_bbm': InternalCommonSharingVisibilityToJSON(value['shareBbm']),
        'share_email': InternalCommonSharingVisibilityToJSON(value['shareEmail']),
        'share_email2': InternalCommonSharingVisibilityToJSON(value['shareEmail2']),
        'share_email3': InternalCommonSharingVisibilityToJSON(value['shareEmail3']),
        'share_mobile_perso': InternalCommonSharingVisibilityToJSON(value['shareMobilePerso']),
        'share_landline_perso': InternalCommonSharingVisibilityToJSON(value['shareLandlinePerso']),
        'share_mobile_pro': InternalCommonSharingVisibilityToJSON(value['shareMobilePro']),
        'share_landline_pro': InternalCommonSharingVisibilityToJSON(value['shareLandlinePro']),
        'share_postal_personal': InternalCommonSharingVisibilityToJSON(value['sharePostalPersonal']),
        'share_postal_work': InternalCommonSharingVisibilityToJSON(value['sharePostalWork']),
        'share_memberships': InternalCommonSharingVisibilityToJSON(value['shareMemberships']),
        'share_educations': InternalCommonSharingVisibilityToJSON(value['shareEducations']),
        'share_experiences': InternalCommonSharingVisibilityToJSON(value['shareExperiences']),
    };
}
